import workspaceQuery from '../../queries/sales/QuotationWorkspaceQuery.graphql';
import listQuery from '../../queries/sales/SalesOrderListQuery.graphql';
import instanceQuery from '../../queries/sales/SalesOrderQuery.graphql';
import defaultQuery from '../../queries/sales/SalesOrderDefault.graphql';
import basicQuery from '../../queries/sales/SalesOrderQueryBasic.graphql';
import mutationQuery from '../../mutations/sales/SalesOrderMutation.graphql';
import temporaryMutationQuery from '../../mutations/sales/SaveOrderTempMutation.graphql';
import aggregateQuery from '../../queries/sales/SalesOrderAggregateQuery.graphql';
import fragment from '../../fragments/sales/SalesOrderFragment.graphql';

import { quoteFormActionsForPermissions } from '../../../actions/sales/SalesOrderAction';
import { salesDocument } from '../../../utils/mailMergeFields';
import { EntityType } from '../../../@types/entityTypes';

const Quotation: EntityType = {
  type: 'SalesOrder',
  title: 'Quotes',
  formTitle: 'Sales Order / Quote',
  formUrl: '/Sales/Quote/Details/',
  workspaceUrl: '/Sales/Quote/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  basic: basicQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderNumber',
  },
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'SALES_QUOTES',
  actions: [...quoteFormActionsForPermissions],
  mergeFields: salesDocument,
};

export default Quotation;
